import Activity from "../../activity/model/Activity";
import ConnectContainerModel from "./ConnectContainerModel";
import SourceItem from "./SourceItem";
import TargetItem from "./TargetItem";

class ConnectActivity extends Activity {
  constructor() {
    super();
    this.activityType = this.CONNECT;
    this.ConnectContainerModel = new ConnectContainerModel();

    this.currentSelectedSource = new SourceItem()
    this.currentSelectedTarget = new TargetItem()
    this.lineList = []
    this.matchingUrl = "http://s3.amazonaws.com/cdn.testengine.com/CONTENT/MATCHING/"
  }

  getAnsweredTrue = () => {

    let { targetItemList } = this.ConnectContainerModel

    targetItemList.forEach(target => {
      if (target.sourceItemList.length != target.solvedSourceItemList.length)
        this.answeredTrue = false
      else {
        target.sourceItemList.forEach(source => {
          let count = 0
          target.solvedSourceItemList.map(function (solvedSource, index) {
            if (solvedSource.sourceIndex == source.sourceIndex)
              count++
          })

          if (count != target.sourceItemList.length)
            this.answeredTrue = false
        });
      }
    });
  }


  resetActivity = () => {
    this.lineList = []

    this.ConnectContainerModel.targetItemList.forEach(element => {
      element.solvedSourceItemList = []
    });

  }


  initFromJson = (obj) => {
    this.initPublicItemsFromJson(obj);
    this.ConnectContainerModel.initFromJson(obj.ConnectContainerModel);


  };


  initFromJsonTest4You = (obj) => {
    this.initPublicItemsFromJsonTest4You(obj);
    this.ConnectContainerModel.initFromJsonTest4You(obj.ConnectContainerModel);


  };

  getAsJson = () => {
    let obj = this.getPublicItemsAsJson();
    obj.ConnectContainerModel = this.ConnectContainerModel.getAsJson();
    // window.projectPlugin.onGetAsJson(obj)

    return obj;
  };

  initSharedItems = (activityArr) => {
    this.initPublicSharedItem(activityArr);
  };

  getReportAsJson = () => {
    let obj = {};

    obj.activityId = this.activityId
    obj.ConnectContainerModel = this.ConnectContainerModel.getAsJson();
    obj.answeredTrue = this.answeredTrue
    obj.activityType= this.activityType
    return obj
  }

  initReportFromJson=(obj)=>{
    this.activityId = obj.activityId
    this.ConnectContainerModel=new ConnectContainerModel()
    this.ConnectContainerModel.initReportFromJson(obj.ConnectContainerModel);
    this.answeredTrue = obj.answeredTrue
  }

}

export default ConnectActivity;
